var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.75C26.6985 33.75 33.75 26.6985 33.75 18C33.75 9.30152 26.6985 2.25 18 2.25C9.30152 2.25 2.25 9.30152 2.25 18C2.25 26.6985 9.30152 33.75 18 33.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 23.64C27.75 23.79 27.705 23.925 27.615 24.045C26.64 25.44 25.335 26.58 23.82 27.36C22.305 28.155 20.625 28.56 18.915 28.56H18.525C15.9 28.47 13.395 27.405 11.505 25.575C9.615 23.76 8.46 21.285 8.28 18.675C8.1 16.05 8.895 13.455 10.5 11.37C12.12 9.3 14.445 7.905 17.04 7.44C17.085 7.44 17.13 7.425 17.175 7.425C17.31 7.44 17.445 7.47 17.55 7.53C17.67 7.605 17.76 7.695 17.835 7.8C17.91 7.905 17.955 8.04 17.97 8.16C17.985 8.295 17.97 8.43 17.925 8.55C17.37 10.08 17.16 11.73 17.34 13.35C17.52 14.97 18.075 16.53 18.945 17.895C19.815 19.275 21 20.43 22.395 21.27C23.79 22.125 25.365 22.635 26.985 22.77C27.12 22.785 27.27 22.83 27.39 22.905C27.51 22.995 27.6 23.1 27.675 23.22C27.735 23.355 27.765 23.505 27.75 23.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoon);
export default __webpack_public_path__ + "static/media/ic-moon.b8ec3d9ea67908ff3f5a6e2c7c7e349d.svg";
export { ForwardRef as ReactComponent };